/** Navigate to an Angular route (hash-bang style). */
export function navigateToAngular(path: string): void {
  window.location.hash = `!${path}`;
}
